let inc = [
    'sl_customer',
    'sl_customer_branch_offices.g_commune',
    'pos_sale',
    'pos_sale.g_seller_user',
    'pos_sale.g_seller_user.hr_employee',
    'pos_sale.payment_types',
    'g_state',
    'wh_detail_dispatch_requests',
    'wh_detail_dispatch_requests.wh_product',
    'wh_detail_dispatch_requests.wh_warehouse',
    'wh_dispatch_request_document_status',
]
let includes = inc.map(
    include =>
        'wh_details_dispatch_request_batch.wh_dispatch_request.' + include
)
export default [
    'supervisor_g_user',
    'supervisor_g_user.hr_employee',
    'g_state',
    'wh_details_dispatch_request_batch',
    ...includes,
]
